import { StoreOutlined } from '@mui/icons-material';
import { Box, Button, Divider } from '@mui/material';

import { BottomSheet } from 'components/docked';
import { CissTextField } from 'components/fields';
import { ChangeStoreGrid } from 'components/header/menu-system/change-store/ChangeStoreGrid';
import { ChangeStoreShellProps } from 'components/header/menu-system/change-store/useChangeStore';

export function ChangeStoreMobile({ open, setOpen, query, setQuery, selectedStore, setSelectedStore, onClickConfirm }: ChangeStoreShellProps) {
    return (
        <BottomSheet
            open={open}
            onOpen={() => setOpen(true)}
            onClose={() => setOpen(false)}
            minHeight={0}
            title={
                <>
                    <StoreOutlined />
                    Trocar empresa
                </>
            }
        >
            <CissTextField
                size="small"
                label="Pesquisar"
                placeholder="Nome fantasia..."
                deboundTime={500}
                sx={{ width: '100%', flexShrink: 0 }}
                onChange={(e) => setQuery(e.target.value)}
            />

            <Box sx={{ height: 'calc(70dvh - 178px)' }}>
                <ChangeStoreGrid query={query} selectedStore={selectedStore} setSelectedStore={setSelectedStore} />
            </Box>

            <Divider sx={{ mx: -2 }} />

            <Box sx={{ display: 'flex', gap: 2 }}>
                <Button variant="outlined" onClick={() => setOpen(false)} fullWidth>
                    Cancelar
                </Button>

                <Button variant="contained" onClick={onClickConfirm} fullWidth disabled={!selectedStore}>
                    Confirmar
                </Button>
            </Box>
        </BottomSheet>
    );
}
